function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M95.35 184.86H206.8v898.37H95.35C42.9 1083.23 0 1040.32 0 987.87V280.21c0-52.45 42.91-95.36 95.35-95.36zM567.91 0h189.77C816.71 0 865 48.3 865 107.33v57.26h-68.38v-57.52c0-20.68-16.92-37.6-37.6-37.6H566.57c-20.68 0-37.6 16.93-37.6 37.6v57.51h-68.38v-57.26c0-59.03 48.3-107.33 107.33-107.33zM263.49 184.86h793.69v898.37H263.49V184.86zm850.38 0h124.1c52.45 0 95.36 42.91 95.36 95.36v707.66c0 52.45-42.91 95.36-95.36 95.36h-124.1V184.87z"
});

var SvgNavbarAbout = function SvgNavbarAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1333.34 1083.23",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavbarAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navbar_about.99edd4da.svg";
export { ForwardRef as ReactComponent };